import { render, staticRenderFns } from "./AilmentCategory.vue?vue&type=template&id=4b5c35a3"
import script from "./AilmentCategory.vue?vue&type=script&lang=ts"
export * from "./AilmentCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports